import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { PublicContentRoutes } from "publicContent/routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Landing } from "marketingSite";

const queryClient = new QueryClient();

const GetAppContext = () => {
  if (window.location.host.split(".")[0] == "app") {
    return <App />;
  }
  if (
    window.location.host.split(".")[0] == "localhost:3000" ||
    window.location.host.split(".")[0] === "gallerystorm"
  ) {
    return <Landing />;
  }
  return <PublicContentRoutes />;
};

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <GetAppContext />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
